import makeStyles from "@mui/styles/makeStyles";

export const usePopoverStyles = makeStyles((theme) => ({
  root: {
    "& .MuiPickersBasePicker-pickerView": {
      minHeight: "auto",
    },
    "& .MuiPickersCalendarHeader-switchHeader": {
      height: 52,
      marginTop: 0,
      background: theme.palette.grey[100],
    },
    "& .MuiPickersCalendarHeader-transitionContainer p": {
      fontSize: 12,
      fontWeight: "bold",
      textTransform: "uppercase",
    },
    "& .MuiPickersCalendarHeader-iconButton": {
      width: 20,
      height: 20,
      margin: "0 16px",
      padding: 0,
      background: "transparent",
      border: `2px solid ${theme.palette.primary.main}`,
    },
    "& .MuiPickersCalendarHeader-iconButton svg": {
      width: 16,
      height: 16,
      color: theme.palette.primary.main,
    },
    "& .MuiPickersCalendarHeader-daysHeader": {
      marginTop: 16,
    },
    "& .MuiPickersCalendar-transitionContainer": {
      minHeight: 230,
    },
  },
}));
